var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0282 6.02685L11.7957 0.794349C11.3948 0.393516 10.8423 0.166016 10.2682 0.166016H2.50065C1.30898 0.166016 0.333984 1.14102 0.333984 2.33268V19.666C0.333984 20.8577 1.30898 21.8327 2.50065 21.8327H15.5007C16.6923 21.8327 17.6673 20.8577 17.6673 19.666V7.56518C17.6673 6.99102 17.4398 6.43852 17.0282 6.02685ZM13.0523 18.301C12.6298 18.7235 11.9473 18.7235 11.5248 18.301L10.2465 17.0227C8.80565 17.7918 6.98565 17.5968 5.77232 16.3835C4.12565 14.7368 4.30982 11.9635 6.31398 10.566C7.57065 9.68852 9.32565 9.68852 10.5932 10.566C12.2723 11.736 12.6515 13.8593 11.774 15.4952L13.0523 16.7735C13.4748 17.196 13.4748 17.8785 13.0523 18.301ZM11.1673 7.74935C10.5715 7.74935 10.084 7.26185 10.084 6.66602V1.79102L16.0423 7.74935H11.1673Z",
    fill: "#444653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45898 15.332C9.35645 15.332 10.084 14.6045 10.084 13.707C10.084 12.8096 9.35645 12.082 8.45898 12.082C7.56152 12.082 6.83398 12.8096 6.83398 13.707C6.83398 14.6045 7.56152 15.332 8.45898 15.332Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditIcon);
export default __webpack_public_path__ + "static/media/auditIcon.fcd2b5ad73cdf7fc1313f6c8a445becb.svg";
export { ForwardRef as ReactComponent };